import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteCarNoteMutation } from "components/CarNoteModal/components/DeleteCarNoteModal/hooks";

type DeleteCarNoteModalProps = {
  id: number;
  open: boolean;
  onClose: () => void;
};

export const DeleteCarNoteModal = ({ id, open, onClose }: DeleteCarNoteModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteCarNote, isPending: isDeleteCarNotePending } = useDeleteCarNoteMutation();

  const handleDeleteCarNoteConfirm = async () => {
    await deleteCarNote(id);
    onClose();
  };

  return (
    <CustomConfirm
      isOpen={open}
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isLoading={isDeleteCarNotePending}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleCancel={onClose}
      handleConfirm={handleDeleteCarNoteConfirm}
    />
  );
};
